import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  sectionNews: {
    display: 'flex',
    flexDirection: 'column'
  },
  moreNews: {
    alignSelf: 'flex-end',
    borderRadius: '30px',
    backgroundColor: theme.palette.primary.dark,
    marginTop: theme.spacing(1),
    height: '2.2rem',
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `2px solid ${theme.palette.primary.contrastText}`,
    '&:hover': {
      border: `2px solid ${theme.palette.primary.contrastText}`
    },
    '& .MuiButton-label .MuiTypography-body1': {
      fontWeight: 600
    },
    [theme.breakpoints.only('xl')]: {
      width: 'auto',
      height: '2.8rem'
    }
  },
  moreNewsText: {
    color: theme.palette.text.secondary
  }
}))
